import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MatOption, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { CustomMessages, EasyDialog } from '@shared';
import { AuditorBenchAuditDetailScopeDetailDTO } from 'app/model/auditor-bench-audit-detail-scope-detail-dto';
import { CommonDTO } from 'app/model/common-dto';
export type DialogDataSubmitCallback<T> = (row: T) => void;
import { AgGridAngular } from 'ag-grid-angular';
import { AgGridModule } from 'ag-grid-angular';
import 'ag-grid-enterprise';
import {
  CellClickedEvent,
  ColDef,
  GridReadyEvent,
  RowGroupingDisplayType,
  SideBarDef,
} from 'ag-grid-community';
import { AuditDetailsService } from 'app/service/audit-details.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ReloadService } from 'app/service/reload.service';
@Component({
  selector: 'app-auditorvisibility-remark',
  templateUrl: './auditorvisibility-remark.component.html',
  styleUrls: ['./auditorvisibility-remark.component.scss'],
})
export class AuditorvisibilityRemarkComponent implements OnInit {
  // Data that gets displayed in the grid
  public rowData: any[];
  value: Object;
  selectedVType: any;
  parsedJson: any;
  checkForStatus: any = '';
  freezeScreen: boolean;
  checkForFirstRemark: any;
  selectedValues: AuditorBenchAuditDetailScopeDetailDTO;
  status: string = '';
  reload = false;
  @ViewChild('allSelected', { static: false }) private allSelected: MatOption;

  isReadonly = true;
  setReadOnly = false;
  isChecked = false;
  textArea = '';
  commonDto: CommonDTO = new CommonDTO();
  // textAreas = [{ value: "" }];
  textAreas = [new FormControl('')];

  auditorBenchAuditDetailScopeDetailDTO: AuditorBenchAuditDetailScopeDetailDTO = new AuditorBenchAuditDetailScopeDetailDTO();
  // @Output() closePanelattachments: EventEmitter<boolean> = new EventEmitter();
  checkforsave: boolean = false;
  input: FormControl = new FormControl('');
  userId: any;
  closedPanel: any = 0;
  public remarksText: string;
  constructor(
    private route: Router,
    private auditDetailsService: AuditDetailsService,
    private customMessage: CustomMessages,
    private reloadserv: ReloadService,
    private dialogRef: MatDialogRef<AuditorvisibilityRemarkComponent>,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA)
    public data: any
  ) {}

  ngOnInit() {
    var char = JSON.parse(localStorage.getItem('clientList'));
    this.userId = char[0].userDetails.userId;
    // this.gvRemarksStatusCheck();
    if (this.data.isClosed == '1') {
      this.status = 'Closed';
    } else {
      this.status = 'Open';
    }
    if (this.data.auditorBenchAuditDetailScopeDetailBean == undefined) {
      this.auditorBenchAuditDetailScopeDetailDTO.scopeId = this.data.scopeCode;
      this.auditorBenchAuditDetailScopeDetailDTO.gvCreatedBy = this.userId;
      this.selectedValues = this.auditorBenchAuditDetailScopeDetailDTO;
      this.isReadonly = false;
      this.setReadOnly = true;
    } else {
      this.auditorBenchAuditDetailScopeDetailDTO.scopeId = this.data.auditorBenchAuditDetailScopeDetailBean[0].scopeId;
      this.auditorBenchAuditDetailScopeDetailDTO.gvCreatedBy = this.userId;
      this.selectedValues = this.auditorBenchAuditDetailScopeDetailDTO;
      // this.isReadonly = true;
    }
    // if (this.data.defaultValue) {
    //   this.input.patchValue(this.data.defaultValue);
    // }
  }
  ngOnDestroy() {
    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }
  checkValue(event: any) {
    if (this.isChecked == true) {
      this.isReadonly = false;
    } else {
      this.isReadonly = true;
    }
  }

  closed() {
    // this.closePanelattachments.emit(false);
  }
  reloadChild() {
    this.reload = true;
  }
  reloading() {
    this.reloadserv.reload();
  }

  load(myArea: string) {
    if (myArea == '' || myArea == '') {
      this.customMessage.showSuccessMessage('cams.label.common.remarkscannotbenull');
      return false;
    }
    this.auditorBenchAuditDetailScopeDetailDTO.scopeId = this.data.auditorBenchAuditDetailScopeDetailBean[0].scopeId;
    this.auditorBenchAuditDetailScopeDetailDTO.gvCreatedBy = this.userId;
    this.auditorBenchAuditDetailScopeDetailDTO.gvRemarks = myArea;
    this.auditorBenchAuditDetailScopeDetailDTO.isGvEnabled = 1;
    this.cdr.detectChanges();
    this.checkforsave = true;
    if (this.data.isClosed == '0') {
      this.auditDetailsService
        .checkforFirstRemark(this.auditorBenchAuditDetailScopeDetailDTO)
        .subscribe(
          data => {
            this.parsedJson = JSON.parse(JSON.stringify(data));
            this.checkForFirstRemark = this.parsedJson.isFirst;
            this.auditorBenchAuditDetailScopeDetailDTO.checkForFirstRemark = this.checkForFirstRemark;
            // this.closePanelattachments.emit(false);
            this.closedPanel = 1;
            // this.reloadComponent();

            if (this.checkForFirstRemark == '0') {
              this.auditDetailsService
                .auditProgramSaveGvRemarks(this.auditorBenchAuditDetailScopeDetailDTO)
                .subscribe(
                  data => {
                    this.customMessage.showSuccessMessage(
                      'cams.label.common.remarksavedSuccessfully'
                    );
                    this.reloading();
                  },
                  error => {
                    this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
                  }
                );
            } else {
              this.auditDetailsService
                .auditProgramSaveGvRemarks(this.auditorBenchAuditDetailScopeDetailDTO)
                .subscribe(
                  data => {
                    this.customMessage.showSuccessMessage(
                      'cams.label.common.remarksavedSuccessfully'
                    );
                    // this.reloadComponent();
                    this.reloading();
                  },
                  error => {
                    this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
                  }
                );
            }
          },
          error => {
            this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
          }
        );
    } else {
      // this.freezeScreen = true;
      this.customMessage.showSuccessMessage('cams.label.common.statusisClosed');
    }
    this.remarksText = '';
    // this.auditDetailsService.auditProgramSaveGvRemarks(this.auditorBenchAuditDetailScopeDetailDTO)
    //   .subscribe(data => {
    //     this.customMessage.showSuccessMessage("cams.label.common.operationCompletedSuccessfully");
    //   }, (error) => {
    //     this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
    //   });
  }
  // refresh() {
  //   this.auditDetailsService.notifyOther({ refresh: true });
  // }
  gvRemarksStatusCheck() {
    var statusCheck;
    this.auditorBenchAuditDetailScopeDetailDTO.scopeId = this.data.auditorBenchAuditDetailScopeDetailBean[0].scopeId;
    this.auditDetailsService
      .checkforgvRemarksStatus(this.auditorBenchAuditDetailScopeDetailDTO)
      .subscribe(
        data => {
          this.parsedJson = JSON.parse(JSON.stringify(data));
          this.checkForStatus = this.parsedJson.isClosed;
          // this.auditorBenchAuditDetailScopeDetailDTO.isclosed = this.checkForStatus;
          statusCheck = this.checkForStatus;
        },
        error => {
          this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
        }
      );
  }
  reloadComponent() {
    this.cdr.detectChanges();
  }
  addTextArea() {
    // this.textAreas.push({ value: "" });
    this.isReadonly = false;
    this.textAreas.push(new FormControl(''));
  }

  removeTextArea(index: number) {
    this.textAreas.splice(index, 1);
  }
  public name = ' ';

  public onValueChange(event: Event): void {
    const value = (event.target as any).value;
    this.name = value;
  }
}
